import React, {Fragment, useMemo, useState} from "react";
import {Col, Radio, Row, Select} from "antd";
import {GUTTER_MD, TABLE_COL_MIN_WIDTH_ID} from "../../../../../styles/constants";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {
    CUBE_CHOICE,
    DATAFLOW_CUBE_CHOICE,
    MDM_CHOICE,
    SELECT_DATAFLOW_CUBE_CHOICES,
    SELECT_TABLE_VIEW_CHOICES, TABLE_CHOICE,
    TABLE_VIEW_CHOICE
} from "./utils";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {selectCurrentTableDatasetBuilder} from "../actions";
import Call from "../../../../../hocs/call";
import {datasetBuilderDataCubeDataFlowList} from "../../actions";

const mapStateToProps = state => ({
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    tableViews: state.scenes.mappingHandler.datasetBuilder.index.tableViews,
    cubes: state.scenes.mappingHandler.datasetBuilder.index.cubes,
    dataflows: state.scenes.mappingHandler.datasetBuilder.index.dataflows,
});

const mapDispatchToProps = dispatch => ({
    setUserSelection: table => dispatch(selectCurrentTableDatasetBuilder(table)),
    fetchCubesAndFlows: (connId) => dispatch(datasetBuilderDataCubeDataFlowList(connId)),
});

const UnionTableSelectAvailable = ({
                                       t,
                                       setUserSelection,
                                       connections,
                                       connId,
                                       tableViews,
                                       cubes,
                                       dataflows,
                                       fetchCubesAndFlows
                                   }) => {
    const [tableViewMDMSelection, setTableViewMDMSelection] = useState(TABLE_VIEW_CHOICE)
    const [selectedTableView, setSelectedTableView] = useState(TABLE_VIEW_CHOICE);
    const [selectedType, setSelectedType] = useState(DATAFLOW_CUBE_CHOICE);
    const cubesAndDataflowObjects = useMemo(() => selectedType === DATAFLOW_CUBE_CHOICE ? [...(cubes || []), ...(dataflows || [])] : selectedType === CUBE_CHOICE ? cubes : dataflows, [cubes, dataflows, selectedType]);
    const tableViewsObjects = useMemo(() => selectedTableView !== TABLE_VIEW_CHOICE ? (tableViews || []).filter(item => selectedTableView === TABLE_CHOICE ? item.type === "table" : item.type === "view") : tableViews, [tableViews, selectedTableView])
    const visibleObjects = useMemo(() => tableViewMDMSelection === TABLE_VIEW_CHOICE ? tableViewsObjects : cubesAndDataflowObjects, [cubesAndDataflowObjects, tableViewsObjects, tableViewMDMSelection])
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);

    return (
        <Call cb={fetchCubesAndFlows} cbParam={connId} disabled={!!cubes || tableViewMDMSelection === TABLE_VIEW_CHOICE}>
            <Fragment>
                {selectedConnection && selectedConnection.dbType === 1 ? <Radio.Group
                    value={tableViewMDMSelection}
                    onChange={({target}) => setTableViewMDMSelection(target.value)}
                >
                    <Radio.Button value={TABLE_VIEW_CHOICE}>
                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.tableView')}
                    </Radio.Button>
                    <Radio.Button value={MDM_CHOICE}>
                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.MDM')}
                    </Radio.Button>
                </Radio.Group> : null}
                <div style={selectedConnection && selectedConnection.dbType === 1 ? {marginTop: GUTTER_MD} : null}>
                    <InfiniteScrollTable
                        multilangStrDataIndexes={["Id"]}
                        data={visibleObjects}
                        getRowKey={({id}) => id}
                        columns={tableViewMDMSelection === MDM_CHOICE ? [{
                            title: t('data.datasetBuilder.type.shortLabel'),
                            dataIndex: 'Type',
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        }, {
                            title: t('data.datasetBuilder.name.shortLabel'),
                            dataIndex: 'Id',
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        }, {
                            title: t('data.datasetBuilder.viewName.label'),
                            dataIndex: 'name',
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        }
                        ] : [{
                            title: t('data.datasetBuilder.type.shortLabel'),
                            dataIndex: 'type',
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        }, {
                            title: t('data.datasetBuilder.name.shortLabel'),
                            dataIndex: 'name',
                            minWidth: TABLE_COL_MIN_WIDTH_ID
                        }
                        ]}
                        onRowClick={(row) => {
                            setUserSelection({
                                tableViewId: row.name,
                                type: row.type || row.Type,
                                name: row.name || row.Code
                            });
                        }}
                        leftActions={<Row type="flex" gutter={GUTTER_MD}>
                            <Col>
                                {tableViewMDMSelection === "MDM" ? (
                                    <Select
                                        showSearch
                                        filterOption={(inputValue, {props}) =>
                                            props.title.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        title={
                                            t('scenes.mappingHandler.DatasetBuilder.dataflowCubeSelector.title')
                                        }
                                        value={selectedType}
                                        onChange={(newValue) => setSelectedType(newValue)}
                                    >
                                        {SELECT_DATAFLOW_CUBE_CHOICES.map((choice) => {
                                            return (
                                                <Select.Option
                                                    key={choice.value}
                                                    value={choice.value}
                                                    title={choice.label}
                                                >
                                                    {choice.label}
                                                </Select.Option>
                                            );
                                        })
                                        }
                                    </Select>
                                ) : (
                                    <Select
                                        showSearch
                                        filterOption={(inputValue, {props}) =>
                                            props.title.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        title={
                                            t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.tableView')
                                        }
                                        value={selectedTableView}
                                        onChange={(newValue) => setSelectedTableView(newValue)}
                                    >
                                        {SELECT_TABLE_VIEW_CHOICES.map((choice) => {
                                            return (
                                                <Select.Option
                                                    key={choice.value}
                                                    value={choice.value}
                                                    title={choice.label}
                                                >
                                                    {choice.label}
                                                </Select.Option>
                                            );
                                        })
                                        }
                                    </Select>
                                )}
                            </Col>
                        </Row>}
                    />
                </div>
            </Fragment>
        </Call>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(UnionTableSelectAvailable);